// import React, { useState, useEffect } from 'react';
// import styled from 'styled-components';
// import { ChevronRight, ChevronLeft } from 'lucide-react';
// // import SwiperSlider from './SwiperSlider';

// const CarouselContainer = styled.div`
//   position: relative;
//   width: 100%;
//   margin: 0 auto;
//   overflow: hidden;
//   margin-top:20px;

//   @media(max-width:968px){
//   display:none;
//   }

// `;

// const CarouselTrack = styled.div`
//   display: flex;
//   transition: transform 0.3s ease-in-out;
//   transform: translateX(${(props) => props.translate}%);
// `;

// const CarouselItem = styled.div`
//   flex: 0 0 25%;
//   padding: 10px;
//   box-sizing: border-box;

//   @media (max-width: 768px) {
//     flex: 0 0 50%;
//   }

//   @media (max-width: 480px) {
//     flex: 0 0 100%;
//   }
// `;

// const ImageCard = styled.div`
//   border-radius: 10px;
//   overflow: hidden;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 100%;
//   height: 100%;

//   img {
//     width: ${({ width }) => width || '100%'};
//     height: ${({ height }) => height || '100%'};
//     object-fit: cover;
//     border-radius: 10px;
//   }
// `;

// const NavButton = styled.button`
//   position: absolute;
//   top: 50%;
//   transform: translateY(-50%);
//   background: rgba(0, 0, 0, 0.25);
//   border: none;
//   border-radius: 50%;
//   width: 30px;
//   height: 30px;
//   font-size: 20px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   cursor: pointer;
//   z-index: 10;

//   &:hover {
//     background: rgba(255, 255, 255, 0.8);
//   }
// `;

// const PrevButton = styled(NavButton)`
//   left: 10px;
// `;

// const NextButton = styled(NavButton)`
//   right: 10px;
// `;

// // Add your image URLs here with height and width
// const carouselItems = [
//   { url: '/assets/images/crousel/4.png', width: '100%', height: '100%' },
//   { url: '/assets/images/crousel/2.png', width: '100%', height: '100%' },
//   { url: '/assets/images/crousel/1.png', width: '100%', height: '100%' },
//   { url: '/assets/images/crousel/3.webp', width: '100%', height: '100%' },
//   { url: '/assets/images/crousel/4.png', width: '100%', height: '100%' },
//   { url: '/assets/images/crousel/2.png', width: '100%', height: '100%' },
//   { url: '/assets/images/crousel/1.png', width: '100%', height: '100%' },
//   { url: '/assets/images/crousel/3.webp', width: '100%', height: '100%' },
// ];

// const CustomSlider = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [itemsPerPage, setItemsPerPage] = useState(4);

//   useEffect(() => {
//     const updateItemsPerPage = () => {
//       if (window.innerWidth <= 480) {
//         setItemsPerPage(1);
//       } else if (window.innerWidth <= 768) {
//         setItemsPerPage(2);
//       } else {
//         setItemsPerPage(4);
//       }
//     };

//     updateItemsPerPage();

//     window.addEventListener('resize', updateItemsPerPage);

//     return () => {
//       window.removeEventListener('resize', updateItemsPerPage);
//     };
//   }, []);

//   const handlePrev = () => {
//     setCurrentIndex((prev) => (prev === 0 ? carouselItems.length - itemsPerPage : prev - itemsPerPage));
//   };

//   const handleNext = () => {
//     setCurrentIndex((prev) => (prev >= carouselItems.length - itemsPerPage ? 0 : prev + itemsPerPage));
//   };

//   // Autoplay functionality
//   useEffect(() => {
//     const autoplay = setInterval(handleNext, 5000); // Change slide every 5 seconds

//     return () => {
//       clearInterval(autoplay); // Clear interval on component unmount
//     };
//   }, [handleNext]);

//   return (
//     <CarouselContainer>
//       <CarouselTrack translate={-currentIndex * (100 / itemsPerPage)}>
//         {carouselItems.map((item, index) => (
//           <CarouselItem key={index}>
//             <ImageCard width={item.width} height={item.height}>
//               <img src={item.url} alt={`carousel item ${index}`} />
//             </ImageCard>
//           </CarouselItem>
//         ))}
//       </CarouselTrack>
//       <PrevButton onClick={handlePrev}>
//         <ChevronLeft />
//       </PrevButton>
//       <NextButton onClick={handleNext}>
//         <ChevronRight />
//       </NextButton>
//     </CarouselContainer>
//   );
// };

// export default CustomSlider;

import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Register from "../../Pages/Auth/Register";
import NewRegister from "../../Pages/Auth/NewRegister";
import CustomeReg from "../../Pages/Auth/CustomeReg";

const CustomSlider = () => {
  const [showRegister, setShowRegister] = useState(false);

  return (
    <div className="bc-home-banner">
      <img
        className="bcgame-home-banner-img"
        src="/assets/bcimages/bchome/bcgame-home-banner.png"
      />
      <img
        className="bcgame-home-banner-img2"
        src="/assets/bcimages/bchome/bcgame-home-banner.png"
      />
      {/* <img
        className="bcgame-home-icon-img"
        src="/assets/bcimages/bchome/bcgame-home-icon.webp"
      /> */}
      <img
        className="bcgame-home-logo-img"
        src="/assets/bcimages/bchome/bcgame-home-logo.webp"
      />
      <div className="bcgame-banner-contant" style={{ marginTop: "10px" }}>
        <p>Stay Untamed</p>

        <div className="bcgame-banner-contant-middle">
          <div
            className="bcgame-banner-signup-text"
            style={{ fontSize: "5px" }}
          >
            <p>Sign Up & Get</p>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <p>UP TO</p>{" "}
              <p style={{ color: "rgb(199, 152, 100)" }}> ₹120,000.00</p>
            </div>
            <p>In Casino And Sports</p>{" "}
          </div>
          {/* <span className='bcgame-banner-contant-middle-span1'>UP TO</span>
            <span className='bcgame-banner-contant-middle-span2'>₹1,697,058.59</span>          
            <div className='bcgame-banner-contant-incasino'>in Games or Sports</div> */}
        </div>
        {/* <button onClick={() => setShowRegister(true)}>Join Now</button>
          {showRegister && <Register />} */}

        {/* <CustomeReg data={"Claim My Bonus Now"} /> */}
      </div>
    </div>
  );
};

export default CustomSlider;
